/** Lowercase without accents, so "jose" finds "José" */
const normalize = (text: string) =>
  text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

/**
 * Every word of `query` starts a word of `name`, e.g. "jo ab" matches
 * "Joshua Abel". An empty query matches everyone
 */
const matchesName = (name: string | undefined, query: string) => {
  const words = normalize(name || '').split(/[\s-]+/)
  return normalize(query)
    .split(/\s+/)
    .filter(Boolean)
    .every((part) => words.some((word) => word.startsWith(part)))
}

export default matchesName
